import * as React from 'react';
import ReactDOM from 'react-dom';

import NotificationListPage from 'components/notification/notifications-page/pc/NotificationListPage';

ReactDOM.render(<NotificationListPage />, document.getElementById('notification-page'));
